export function setUser(state, user) {
  state.user = user;
}
export function setToken(state, token) {
  state.token = token;
}



